import Joyride from "react-joyride";
import { useOnboardingTour } from "./useOnboardingTour";
import type { OnboardingTourProps } from "./types";
import { useLanguage } from "@/contexts/LanguageContext";

function getBrandColor() {
  const raw = getComputedStyle(document.documentElement).getPropertyValue("--brand").trim();
  return `hsl(${raw || "263 90% 65%"})`;
}

export function OnboardingTour({ pageReady }: OnboardingTourProps) {
  const { run, steps, handleCallback, isRTL } = useOnboardingTour(pageReady);
  const { t } = useLanguage();
  const brandColor = getBrandColor();

  if (!run) return null;

  return (
    <Joyride
      steps={steps}
      run={run}
      callback={handleCallback}
      continuous
      showSkipButton
      showProgress
      spotlightClicks
      disableOverlayClose
      scrollOffset={100}
      locale={{
        next: t.onboardingTour.next,
        back: t.onboardingTour.back,
        skip: t.onboardingTour.skip,
        last: t.onboardingTour.finish,
        close: t.onboardingTour.close,
        nextLabelWithProgress: t.onboardingTour.nextLabelWithProgress,
        open: t.onboardingTour.open,
      }}
      styles={{
        options: {
          zIndex: 10000,
          primaryColor: brandColor,
          textColor: "#e2e8f0",
          backgroundColor: "hsl(240, 10%, 10%)",
          arrowColor: "hsl(240, 10%, 10%)",
          overlayColor: "rgba(0, 0, 0, 0.6)",
        },
        tooltip: {
          borderRadius: 16,
          padding: "20px 24px",
          direction: isRTL ? "rtl" : "ltr",
          textAlign: isRTL ? "right" : "left",
        },
        tooltipTitle: {
          fontSize: 16,
          fontWeight: 700,
          textAlign: isRTL ? "right" : "left",
        },
        tooltipContent: {
          fontSize: 14,
          padding: "8px 0 0",
          textAlign: isRTL ? "right" : "left",
        },
        buttonNext: {
          borderRadius: 10,
          padding: "8px 20px",
          fontSize: 14,
          fontWeight: 600,
        },
        buttonBack: {
          color: "#94a3b8",
          fontSize: 14,
          marginRight: isRTL ? 0 : 8,
          marginLeft: isRTL ? 8 : 0,
        },
        tooltipFooter: {
          flexDirection: isRTL ? "row-reverse" : "row",
          justifyContent: "space-between",
        },
        tooltipFooterSpacer: {
          flex: "none",
        },
        buttonClose: {
          left: isRTL ? 8 : "auto",
          right: isRTL ? "auto" : 8,
        },
        buttonSkip: {
          color: "#64748b",
          fontSize: 13,
        },
        spotlight: {
          borderRadius: 16,
        },
      }}
    />
  );
}
